import type { ComponentProps } from "react";
import { Slot } from "radix-ui";
import { joinClassNames } from "@/lib/classNames";
import styles from "./Button.module.css";

type ButtonProps = ComponentProps<"button"> & {
  asChild?: boolean;
  variant?: "primary" | "secondary" | "danger" | "ghost" | "icon";
  size?: "sm" | "md" | "icon";
};

export function Button({
  className,
  asChild = false,
  type = "button",
  variant = "primary",
  size = variant === "icon" ? "icon" : "md",
  ...props
}: ButtonProps) {
  const Component = asChild ? Slot.Root : "button";

  return (
    <Component
      data-slot="button"
      data-variant={variant}
      data-size={size}
      className={joinClassNames(styles.button, className)}
      type={asChild ? undefined : type}
      {...props}
    />
  );
}
